<template>
  <div
    class="item"
    :class="{ 'no-hover': !hover, 'no-pointer': !pointer }"
    :style="{ height: height + 'px' }"
    @click="handleClick"
    v-bind="$attrs"
  >
    <div v-if="title || icon || $slots.title || $slots.prepend">
      <div class="d-flex align-items-center" style="gap: 10px">
        <!-- Prepend -->
        <slot name="prepend">
          <i v-if="icon" :class="icon"></i>
        </slot>

        <!-- Title -->
        <slot name="title">
          <span v-if="title">{{ title }}</span>
        </slot>
      </div>
    </div>

    <!-- Append -->
    <div v-if="append || $slots.append">
      <slot name="append">
        <span v-if="append !== 'undefined'">{{ append }}</span>
      </slot>
    </div>

    <!-- Content -->
    <slot></slot>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    title: String,
    icon: String,
    append: [String, Number],
    hover: {
      type: Boolean,
      default: true,
    },
    pointer: {
      type: Boolean,
      default: true,
    },
    height: {
      type: [String, Number],
      default: 38,
    },
  },

  methods: {
    handleClick(event) {
      this.$emit("click", event);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./gListItem.scss";
</style>
